export enum AccessType {
  Broker = 1,
  Client = 2,
  BrokerCompany = 3,
  BrokerCompanyUser = 4,
}
